import { editorStyles, headingStyles, imageAndFigureStyles, linkStyles, listStyles, miscStyles, tableStyles, textStyles, } from '../htmlStyle';
export const HtmlContentStyle = (theme) => `
  ${miscStyles()}
  ${linkStyles(theme)}
  ${imageAndFigureStyles()}
  ${headingStyles()}
  ${editorStyles()}
  ${textStyles(theme)}
  ${tableStyles()}
  ${listStyles()}
`;
export { htmlContentAdditionalStyles } from '../htmlStyle';
//# sourceMappingURL=styles.js.map